import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState } from 'react';
import createContainer from 'constate';

function useSearchState() {
  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      searchTerm = _useState2[0],
      setSearchTerm = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      searching = _useState4[0],
      setSearchBoxVisibility = _useState4[1]; // todo: create a hook for Visibility behavior


  function toggleSearchBox(userVisible) {
    if (userVisible !== undefined) {
      setSearchBoxVisibility(userVisible);
    } else {
      setSearchBoxVisibility(!searching);
    }
  }

  function reset() {
    setSearchTerm('');
    setSearchBoxVisibility(false);
  }

  return {
    state: {
      searchTerm: searchTerm,
      searching: searching
    },
    setSearchTerm: setSearchTerm,
    toggleSearchBox: toggleSearchBox,
    reset: reset
  };
}

var SearchState = createContainer(useSearchState, function (value) {
  return [value.state];
});

export default SearchState;
//# sourceMappingURL=SearchState.js.map
